const AWS_REGION = "ap-south-1";
const APP_BUCKET_REGION = "ap-south-1";
const KNOWLEDGE_BASE_BUCKET_REGION = "us-east-1";
const DEV_HOSTNAMES = new Set([
  "localhost",
  "127.0.0.1",
  "dev.bms.yandle.io",
  "www.dev.bms.yandle.io",
]);

const DEV_CONFIG = {
  userPoolId: "ap-south-1_xBO1BlE7w",
  userPoolClientId: "75c2r9flouk2pe71r05p51j912",
  identityPoolId: "ap-south-1:de8ab271-11f3-4331-a954-6cb2e9372544",
  graphqlEndpoint:
    "https://mvdzn5nto5adlnwcottv5hmjuy.appsync-api.ap-south-1.amazonaws.com/graphql",
  bucket: "yandle-dev",
  bucketRegion: APP_BUCKET_REGION,
  knowledgeBaseBucket: "yandle-kb-dev",
  knowledgeBaseBucketRegion: KNOWLEDGE_BASE_BUCKET_REGION,
};
const PROD_CONFIG = {
  userPoolId: "ap-south-1_mynbuEFKV",
  userPoolClientId: "24ca9tqtmut0antj72pb5d0kn2",
  identityPoolId: "ap-south-1:a25bc3f4-4a45-4956-86b7-965e1d8d68c4",
  graphqlEndpoint:
    "https://5dnj46636jgrdjlvrf6abamrby.appsync-api.ap-south-1.amazonaws.com/graphql",
  bucket: "yandle-prod",
  bucketRegion: APP_BUCKET_REGION,
  knowledgeBaseBucket: "yandle-kb-prod",
  knowledgeBaseBucketRegion: KNOWLEDGE_BASE_BUCKET_REGION,
};
export const STORAGE_MODULE = {
  ORGANIZATION: "organization",
  DEFAULT: "default",
};

export const AWS_ENVIRONMENTS = {
  dev: DEV_CONFIG,
  prod: PROD_CONFIG,
};

// Real deployments (dev.bms.yandle.io / the prod domain) are always resolved
// by hostname below, on purpose -- this override only matters on localhost,
// where the hostname alone can't say which backend you want. Set
// VUE_APP_BMS_ENV=prod|dev in .env.local (gitignored, personal to your
// machine) to flip it, then restart `npm run serve`.
function getLocalBmsEnvOverride() {
  const value = String(process.env.VUE_APP_BMS_ENV ?? "").trim().toLowerCase();
  return value === "dev" || value === "prod" ? value : null;
}

export function resolveAwsEnvironment(hostname = window.location.hostname) {
  const override = getLocalBmsEnvOverride();
  if (override) return override;
  const host = String(hostname || "")
    .trim()
    .toLowerCase()
    .replace(/^\[|\]$/g, "");
  return DEV_HOSTNAMES.has(host) ? "dev" : "prod";
}

export function getAwsEnvironmentConfig(hostname = window.location.hostname) {
  const environment = resolveAwsEnvironment(hostname);
  const envConfig = environment === "dev" ? DEV_CONFIG : PROD_CONFIG;

  return {
    environment,
    region: AWS_REGION,
    graphqlApiKey: process.env.VUE_APP_AWS_COGNITO_GRAPHQL_API_KEY,
    ...envConfig,
  };
}

export function getStorageBucketForModule(
  module = STORAGE_MODULE.DEFAULT,
  hostname = window.location.hostname,
) {
  const config = getAwsEnvironmentConfig(hostname);
  return module === STORAGE_MODULE.ORGANIZATION
    ? config.knowledgeBaseBucket
    : config.bucket;
}

export function getStorageBucketRegionForModule(
  module = STORAGE_MODULE.DEFAULT,
  hostname = window.location.hostname,
) {
  const config = getAwsEnvironmentConfig(hostname);
  return module === STORAGE_MODULE.ORGANIZATION
    ? config.knowledgeBaseBucketRegion
    : config.bucketRegion;
}

export function getStorageBucketRegistry(
  config = getAwsEnvironmentConfig(),
) {
  return {
    [STORAGE_MODULE.DEFAULT]: {
      bucketName: config.bucket,
      region: config.bucketRegion,
    },
    [STORAGE_MODULE.ORGANIZATION]: {
      bucketName: config.knowledgeBaseBucket,
      region: config.knowledgeBaseBucketRegion,
    },
  };
}

export function withStorageBucket(
  module = STORAGE_MODULE.DEFAULT,
  options = {},
) {
  return {
    ...options,
    bucket: module,
  };
}
